export default __webpack_public_path__ + "static/media/profile6.d642838a.png";